import {useQueryClient} from '@tanstack/react-query';
import {I18n} from '@aws-amplify/core';
import {ReloadButton} from '@flexinet/ui-components';

import {productsKeys} from '../hooks/useProductsQuery';

export const ReloadRecordsButton = () => {
    const queryClient = useQueryClient();

    return (
        <ReloadButton
            aria-label={I18n.get('Reload products')}
            onClick={() => queryClient.invalidateQueries({queryKey: productsKeys.lists()})}
        />
    );
};
